"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEndIndices = void 0;
const generateEndIndices = (cells, startIndex) => {
    if (cells.length === 0) {
        return [];
    }
    const endIndices = [];
    for (let endIndex = startIndex + 1; endIndex < cells.length - 1; ++endIndex) {
        if (!cells[endIndex + 1].hasTile()) {
            endIndices.push(endIndex);
        }
    }
    endIndices.push(cells.length - 1);
    return endIndices;
};
exports.generateEndIndices = generateEndIndices;
